"use client";

import { getText } from "@/lib/i18n";
import { motion } from "motion/react";
import Link from "next/link";

export function Footer() {
  return (
    <motion.footer
      className="bg-background border-t"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.5 }}
    >
      <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-24 lg:flex lg:justify-between">
          {/* Company Info */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-foreground mb-4">
              {getText("footer.productName")}
            </h3>

            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-sm text-muted-foreground mb-4 md:mb-0">
                © {new Date().getFullYear()},{getText("footer.reserved")}
              </div>
            </div>
          </div>

          {/* Resources */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-foreground mb-4">
              {getText("footer.resources")}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/faq"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.faq")}
                </Link>
              </li>
              <li>
                <Link
                  href="/"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.home")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Tools */}
          {/* <div className="col-span-1">
            <h3 className="text-sm font-semibold text-foreground mb-4">
              {getText("footer.tools")}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/tools/ip-checker"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.ipChecker")}
                </Link>
              </li>
              <li>
                <Link
                  href="/tools/speed-test"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.speedTest")}
                </Link>
              </li>
              <li>
                <Link
                  href="/tools/dns-leak-test"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.dnsLeakTest")}
                </Link>
              </li>
              <li>
                <Link
                  href="/tools/vpn-comparison"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.vpnComparison")}
                </Link>
              </li>
            </ul>
          </div> */}

          {/* Legal */}
          <div className="col-span-1">
            <h3 className="text-sm font-semibold text-foreground mb-4">
              {getText("footer.help")}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/privacy"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.privacyPolicy")}
                </Link>
              </li>
              <li>
                <Link
                  href="/service"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {getText("footer.termsOfService")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </motion.footer>
  );
}
